export default __webpack_public_path__ + "static/media/product13.8fb861a0.png";